var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Archive component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTextBold extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="#3F3F3F"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.39792 0.824268C5.15826 0.876996 4.91336 1.10684 4.84868 1.33979C4.8154 1.45962 4.81446 22.5371 4.84772 22.6569C4.90883 22.8768 5.13052 23.1001 5.35189 23.1646C5.51022 23.2107 13.9331 23.2108 14.3039 23.1647C15.0901 23.0669 15.7388 22.8752 16.4279 22.5369C17.0735 22.2201 17.5781 21.8564 18.1092 21.3254C19.3355 20.099 19.974 18.5591 19.9754 16.824C19.9758 16.2979 19.9532 16.0575 19.8568 15.5648C19.4341 13.4047 17.8378 11.5532 15.7679 10.8223C15.6293 10.7733 15.5195 10.724 15.5239 10.7127C15.5283 10.7013 15.6279 10.6056 15.7451 10.5C16.6231 9.70916 17.237 8.62343 17.4684 7.45204C17.6239 6.665 17.5929 5.70592 17.3873 4.94404C17.0303 3.62101 16.2077 2.48053 15.0599 1.71695C14.5643 1.38726 13.8078 1.06451 13.2359 0.938748C12.6079 0.800628 12.8163 0.807444 9.02389 0.800868C6.33335 0.796188 5.50115 0.801564 5.39792 0.824268ZM6.33589 6.371V10.44H9.28667C12.4436 10.44 12.5234 10.4374 12.9906 10.3183C14.2956 9.98545 15.3555 9.02987 15.8169 7.77016C16.0977 7.00345 16.1368 6.10379 15.9235 5.31604C15.6524 4.31483 15.0095 3.45714 14.1172 2.90644C13.8072 2.71516 13.3613 2.52577 13.0088 2.4357C12.5387 2.3156 12.6499 2.31944 9.38989 2.31042L6.33589 2.30197V6.371ZM6.33589 16.8242V21.6975L10.2299 21.6889C14.4849 21.6795 14.2277 21.6879 14.8112 21.5403C16.0311 21.232 17.111 20.4308 17.7748 19.3415C18.3095 18.464 18.5555 17.3823 18.454 16.3542C18.293 14.7226 17.3257 13.2795 15.8821 12.5168C15.4257 12.2757 14.9477 12.1142 14.3756 12.0077C14.1651 11.9685 13.8536 11.9648 10.2419 11.9581L6.33589 11.9508V16.8242Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTextBold.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTextBold.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTextBold.prototype, "size", void 0);
if (customElements.get('cat-icon-text-bold') === undefined) {
    customElements.define('cat-icon-text-bold', BlocksIconTextBold);
}
